import React from 'react';
import { EuroSignPosition, formatPrice } from '../utils/format-price';

export interface PriceBreakdownRowProps {
  title: string;
  value: number;
  isHighlighted?: boolean;
  isVisible?: boolean;
  footnoteNumber?: number | null;
  testIdTitle?: string;
  testIdValue?: string;
}

export default function PriceBreakdownRow({
  title,
  value,
  isHighlighted = false,
  isVisible = true,
  footnoteNumber = null,
  testIdTitle,
  testIdValue,
}: PriceBreakdownRowProps) {
  if (value === 0 || !isVisible) return null;

  return (
    <div
      className={`${isHighlighted && 'bg-[var(--color-card-primary)] font-medium rounded-[10px] p-2 my-2'} flex pb-2 px-2`}
      key={title}
    >
      <span
        data-testid={testIdTitle ?? `${title}-title`}
        className={`basis-2/3 ${isHighlighted && 'font-medium'}`}
      >
        {!!footnoteNumber ? (
          <>
            {title}
            <sup>{footnoteNumber}</sup>
          </>
        ) : (
          title
        )}
      </span>
      <span>€</span>
      <span
        data-testid={testIdValue ?? `${title}-value`}
        className={`basis-1/3 text-end ${isHighlighted && 'font-medium'}`}
      >
        {formatPrice(value, true, EuroSignPosition.None)}
      </span>
    </div>
  );
}
